import { useEffect, useState } from "react";
import BreadCrumb from "../../../components/BreadCrumb/Breadcrumb";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useParams } from "react-router-dom";
import { httprequest } from "../../../data/api";
import { ToastContainer, toast } from "react-toastify";
import Layout from "../../../components/Layout/Layout";
import StaffProfile from "./StaffProfile";
import RenumerationDetails from "./RenumerationDetails";
import Resume from "./Resume";
// import { useUserState } from "../../../context/UserContext";

// --Staff EndPoint
const STAFF_ENDPOINT = "/admin/v1/teacher";
// -- SCHOOL ENDPOINT
// const SCHOOL_ENDPOINT = "/admin/v1/schools";

const AboutStaff = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  // const [schoolData, setSchoolData] = useState([]);
  const [value, setValue] = useState("1");
  // const { profile } = useUserState();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAboutStaff = () => {
    httprequest.get(`${STAFF_ENDPOINT}/${id}`).then((res) => {
      // eslint-disable-next-line no-console
      console.log(res?.data);
      setData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  // const handleGetSchool = () => {
  //   httprequest.get(`${SCHOOL_ENDPOINT}/${org_id}`).then((res) => {
  //     // eslint-disable-next-line no-console
  //     console.log(res?.data);

  //     setSchoolData(res?.data?.data);
  //   }).catch((err) => {
  //     toast.error(err?.response?.data);
  //   });
  // };

  useEffect(() => {
    handleAboutStaff();
    // handleGetSchool();
  }, []);

  return (
    <Layout
      children={
        <>
          <BreadCrumb
            link_one="/schools"
            link_one_name="School"
            link_two={`/schools/${data?.school_id}`}
            link_two_name={`${data?.school_name}`}
            active={`${`${data?.first_name} ${data?.last_name}`}`}
            description={`See the staff in ${data?.school_name}.`}
          />
          <TabContext value={value}>
            <div className="tablist-container">
              <Tabs
                indicatorColor="none"
                className="overide-tablist"
                onChange={handleChange}
                aria-label=""
              >
                <Tab label="Profile" value="1" />
                <Tab label="Resume CV" value="2" />
                <Tab label="Renumeration Details" value="3" />
              </Tabs>
            </div>
            <TabPanel value="1" className="tabpanel-overide"><StaffProfile /></TabPanel>
            <TabPanel value="2" className="tabpanel-overide"><Resume /></TabPanel>
            <TabPanel value="3" className="tabpanel-overide"><RenumerationDetails /></TabPanel>
          </TabContext>
          <ToastContainer />
        </>
      }
    />
  );
};

export default AboutStaff;
